import { apiSlice } from "../apiSlice";
const companyUrl = `${process.env.REACT_APP_BASE_URL}/api/v1/company`;

export const CompanyApiSlice = apiSlice.injectEndpoints({
    endpoints:(builder)=>({
      createCompany:builder.mutation({
        query:(data)=>({
            url:`${companyUrl}/add-company`,
            method:'POST',
            body:data
        }),
        invalidatesTags: ['companies']
       }),
       getCompany:builder.query({
        query:()=>({
            url:`${companyUrl}/get-company`,
            method:'GET',
        }),
        providesTags: ['gsttypes']
       }),
    }),
    
})

export const {  useCreateCompanyMutation,useGetCompanyQuery } = CompanyApiSlice